/*
 * Sample inbox for loans@oelement.ai. UI only: nothing here is connected to a
 * real mailbox. The emails are written the way deals actually arrive, so the
 * extractor has something realistic to read.
 */

export const LOAN_INBOX_ADDRESS = "loans@oelement.ai";

export const SAMPLE_LOAN_EMAILS = [
  {
    id: "m1",
    fromName: "Tim Nguyen",
    fromEmail: "tim@gtcbrokerage.com",
    subject: "New deal - Stockton Blvd refi, need a lender",
    receivedAt: "2026-09-22 08:41",
    body: `Tina,

Got this one from a referral this morning. Can you find a lender for it?

Borrower is Pham Family Holdings LLC. Property is a 12-unit apartment building at 4410 Stockton Blvd, Sacramento, CA 95820. Fully leased, 100% occupied.

Current loan matures March 2027 and they want a cash-out refinance. Loan amount they are looking for is about $1,850,000. Property was appraised at $2,900,000 last year so that is roughly 64% LTV. Current rate is 4.25% fixed.

NOI is $212,000 and DSCR is 1.38x on the new loan. Credit score 760. They need to close by December 15 because the current lender is not extending.

They prefer a bank lender, no hard money. Contact is Danny Pham, (916) 555-0148.

Tim`,
  },
  {
    id: "m2",
    fromName: "Vanna Truong",
    fromEmail: "vtruong@enterprisebank.com",
    subject: "FW: Owner-user purchase, SBA 504 candidate",
    receivedAt: "2026-09-21 16:05",
    body: `Tina, see below, this one came to me but it is really a broker deal first. Vanna

---------- Forwarded message ----------
From: Marco Delgado <marco@delgadodental.com>

Hi Vanna,

My dental practice is buying the building we have been renting. Purchase price is $3,400,000 for a medical office building at 2215 Fair Oaks Blvd, Suite 100, Sacramento, CA 95825. We occupy about 70% of the building and lease the rest.

We would like an SBA 504 loan, requesting $3,060,000 (90% LTV). Business has been profitable 8 years. My credit score is 745. NOI from the tenant space is around $95,000.

We are in contract and need to close by November 30. Prefer an SBA lender that can move fast.

Marco Delgado
Delgado Dental Group
916-555-0192`,
  },
  {
    id: "m3",
    fromName: "Alicia Romero",
    fromEmail: "alicia.romero@gmail.com",
    subject: "Refinance question - strip center in Elk Grove",
    receivedAt: "2026-09-19 11:22",
    body: `Hello,

I got your name from a friend. I own a retail strip center at 9050 Elk Grove Blvd, Elk Grove, CA 95624. It is 6 units, 83% occupied, one vacancy I am filling now.

The loan comes due 06/2027 and I want a rate and term refinance, no cash out. Balance is about $2.1M, and I think the property is worth around $3.6M. NOI last year was $265,000. Current rate 5.9%.

No rush yet but I want to be done in 90 days. Open to a credit union or bank.

Thanks,
Alicia Romero
(916) 555-0177`,
  },
  {
    id: "m4",
    fromName: "Raymond Ortiz",
    fromEmail: "rortiz@sacvalleyrealty.com",
    subject: "Quick one - bridge on a fourplex",
    receivedAt: "2026-09-18 09:10",
    body: `Tina, quick one from my buyer. Borrower Kevin Tran wants a bridge loan on a fourplex at 731 Broadway, Sacramento, CA 95818. Purchase price $1,150,000, he needs $800,000, so 70% LTV. Vacant, he is renovating then refinancing. Wants private money, needs to close in 3 weeks. Credit 690. kevin.tran@outlook.com, 916-555-0133.

Raymond Ortiz
Sac Valley Realty`,
  },
  {
    id: "m5",
    fromName: "Alicia Romero",
    fromEmail: "alicia.romero@gmail.com",
    subject: "Re: Refinance question - strip center in Elk Grove",
    receivedAt: "2026-09-20 14:02",
    body: `Following up on my email from yesterday with the numbers you asked for.

Credit score is 778. The loan balance is $2,080,000 and I would like to borrow $2,100,000. DSCR on the current payment is 1.55x. I would like to close by December 1.

Alicia`,
  },
];
